<template>
  <DashboardMenu />
  <div class="container">
    <div class="accounts">
      <p class="accounts__header">Импорт доноров</p>
      <textarea
        v-model="listAccs"
        ref="inputAccs"
        :readonly="waitResponse"
        placeholder="login||password||2fa||shop||userAgent||proxy"
        id="inputAccs"
        spellcheck="false"
      ></textarea>

      <label>Прокси</label>
      <input type="text" name="proxy" v-model="proxy" id="" />
      <small>Используется только при добавлении, если у донора нет прокси</small>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        "
      >
        <button
          class="btn btn__check unselect ld-ext-right"
          ref="addAccounts"
          @click="addAccounts"
          :class="{
            loading: waitResponse,
            running: waitResponse,
          }"
          :disabled="!listAccs.length || waitResponse"
        >
          Добавить
          <div class="ld ld-ring ld-spin-fast"></div>
        </button>
        <button
          @click="clearListAccs"
          :disabled="waitResponse"
          class="btn btn__clear unselect"
        >
          Очистить
        </button>
        <!-- <button class="btn btn__test unselect">Тест</button> -->
      </div>
    </div>
    <div class="result">
      <p class="result__header">Результат</p>

      <DynamicScroller
        :items="task.data"
        :min-item-size="22"
        @scroll.self="syncIO"
        ref="scroller"
        class="textarea"
        style="padding: 10px 0"
      >
        <template v-slot="{ item }">
          <DynamicScrollerItem :item="item">
            <div class="res">
              {{ item }}
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
    </div>
  </div>
</template>

<script>
import DashboardMenu from '@/components/DashboardMenu.vue';

export default {
  data() {
    return {
      proxy: 'socks://bioshok2911:f1981d@145.239.27.80:10018',
      waitResponse: false,
      listAccs: '',
      listAccsArray: [],
      filterAccounts: [],
      task: {
        percent: 0,
        data: [],
        info: {}
      }
    };
  },

  computed: {},

  methods: {
    clearListAccs() {
      this.listAccs = '';
      this.listAccsArray = [];
      this.task.data = [];
      this.task.percent = 0;
      this.task.info = {};
      this.filterAccounts = [];
      // Очистка тем даты
      delete localStorage.accountsData;

      this.$refs.inputAccs.focus();
    },
    syncIO({ target }) {
      const { scrollTop } = target;

      this.$refs.inputAccs.scrollTop = scrollTop;
      // this.$refs.results.scrollTop = scrollTop;
    },
    async addAccounts() {
      this.waitResponse = true;
      this.listAccsArray = [];
      this.task.data = [];
      this.task.percent = 0;
      this.task.info = {};

      // Удаляем дубли, пробелы в списке акков, лишние символы в начале/конце строки и обновляем список
      const uidList = [
        ...new Set(
          this.listAccs
            .split('\n')
        )
      ];

      // const uidList = this.listAccs.split('\n');

      this.listAccs = uidList.join('\n').trim();
      this.listAccsArray = uidList;

      // Разбиваем список аккаунтов на части
      const perChunk = 1;
      const uidListChunk = uidList.reduce(
        (chunks, el, i) =>
          (i % perChunk
            ? chunks[chunks.length - 1].push(el)
            : chunks.push([el])) && chunks,
        []
      );

      // console.log(uidList);
      // console.log(uidListChunk);
      
      // Отправляем запрос
      for (const list of uidListChunk.values()) {
        try {
          console.log({ list });
          const token = localStorage.getItem('adminAuthToken');
          const response = await this.axios.post('donors/', {
            headers: {
              'Authorization': 'Bearer '+token
            },
            data: {
              list: list,
              proxy: this.proxy
            }
          });

          console.log({ response })

          this.task.data.push(response.data.msg);

          // Вычисляем % выполнения задачи
        } catch (err) {
          // alert(err.message);
          this.showToaster(err.message);
          break;
        }
      }

      // Подгружаем актуальные данные по пользователю
      // this.axios.get('user/me').then((resp) => {
      //   this.$store.state.user = resp.data.user;
      //   localStorage.userInfo = JSON.stringify(resp.data.user);
      // });

      // Сохраняем темп дату, если данных меньше 10к

      // Разблокировка кнопок и полей
      this.waitResponse = false;
    },
    showToaster(msg) {
      this.$toast.show(msg, {
        position: 'top'
        // duration: false,
      });
    }
  },

  mounted() {},
  components: { DashboardMenu }
};
</script>

<style lang="scss" scoped>
.accounts {
  label {
    margin: 10px 0 10px 0;
    display: flex;
  }

  input {
    display: flex;
    width: 100%;
    padding: 8px 12px;
    color: rgba(0, 0, 0, 0.87);
    font-family: 'Ubuntu';
    margin: 0;
    padding: 10px;
    font-size: 14px;
    outline-color: #28a0a0;
    border-radius: 5px;
    border: 2px solid grey;
  }

  small {
    display: flex;
    margin-bottom: 10px;
  }
}
/* .container {
  flex-direction: column;
  align-items: center;
} */
</style>